module.exports = __webpack_public_path__ + "assets/cta-decoration-tl.755cbf7c.png";